import styled from "styled-components";
import { colors } from "../../../../../../../theme/theme";
import { Col } from "react-bootstrap";

export const PendencyList = styled.div`
	display: flex;
	flex-direction: column;

	max-height: max(45svh, 200px);
`;

export const PendencyListHeader = styled.div.attrs((props) => ({
	//@ts-ignore
	hasReason: props.hasReason || false,
}))`
	display: grid;
	grid-template-columns: ${(props) =>
		props.hasReason ? `2fr 1fr 1fr 2fr` : `2fr 1fr 1fr`};

	place-items: center;
	gap: 16px;
	padding: 16px;

	span {
		font-size: 14px;
		font-weight: bold;
		color: ${colors.greyscale.black};

		/* o nome do material */
		&:first-child {
			place-self: center start;
			text-align: left;
		}
	}
`;
export const PendencyListBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding-bottom: 16px;

	span {
		font-weight: normal;
		color: ${colors.greyscale.dark_grey};

		/* o nome do material */
		&:first-child {
			color: ${colors.greyscale.darker_grey};
		}
	}
`;
export const PendencyListItem = styled(PendencyListHeader)`
	border: 1px solid ${colors.greyscale.grey};
	border-radius: 4px;

	span:first-child {
		max-width: 160px;
		word-break: break-word;
	}
`;

export const BatchModalMessage = styled(Col)`
	text-align: left;

	h3 {
		font-size: 16px;
		color: ${colors.greyscale.darker_grey};
		margin: 0 0 1em;
		font-weight: bold;
	}

	p {
		font-size: 14px;
	}
`;

export const ReadyToPublishList = styled(Col)`
	text-align: left;
	padding: 0;

	.p-treetable {
		margin-top: 16px;
		max-height: 310px;
		overflow-y: auto;
	}
`;
